import { Link } from "react-router-dom";
import { IoBeer } from "react-icons/io5";
import { IoHome } from "react-icons/io5";
import { BiArrowToTop } from "react-icons/bi";
import { MdOutlineMore } from "react-icons/md";

import { Button } from "../../components/Button";
import { useDrinks } from "../../providers/beers";
import { useMarriageDrink } from "../../providers/marriage";

import { Container, Foot, Head } from "./styles";

export const Marriage = () => {
  const { isClose, setIsClose } = useDrinks();

  const { marriageDrink, setMarriageDrink, removeDrinkMarriage, localHousing } =
    useMarriageDrink();

  const openDescriptionModal = () => setIsClose(!isClose);

  const removeAll = () => {
    setMarriageDrink([]);
    localHousing();
  };

  return (
    <>
      <Head>
        <h1>Casamento</h1>
        <IoBeer />
        <Link to="/">
          <IoHome />
        </Link>
      </Head>
      <Container>
        {marriageDrink.map((beer, index) => (
          <div className="main" key={index}>
            <img src={beer.image_url} alt={beer.name} />
            <p className="drinkName">{beer.name}</p>
            <p className="first-brewed">{beer.first_brewed}</p>
            <div className="viewMore">
              <span>
                Description
                <MdOutlineMore onClick={openDescriptionModal} />
              </span>
              {isClose === false && (
                <div className="description">{beer.description}</div>
              )}
            </div>
            <p className="volume">
              {beer.volume.value} {beer.volume.unit}
            </p>
            <Button onClick={() => removeDrinkMarriage(beer)}>Remover</Button>
          </div>
        ))}
      </Container>
      <Foot>
        <Button onClick={removeAll}>Remover Todas</Button>
        <a href="#top">
          <BiArrowToTop />
        </a>
      </Foot>
    </>
  );
};
